import React from 'react';
import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import PlusIcon from 'mdi-react/PlusIcon';
import MinusIcon from 'mdi-react/MinusIcon';

type Props = {
  strings?: Array<string | undefined | null>;
  type: 'pros' | 'cons';
};

const ICON_WRAPPER_SIZE = 20;
const ICON_SIZE = 14;

const ProsConsRow = styled.div<Props>`
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  align-items: center;
  column-gap: ${layout.measurements.spacingSmall};
  color: ${p =>
    p.type === 'pros' ? p.theme.text.primary : p.theme.text.secondary};
`;

const Icon = styled.span<Props>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: ${ICON_WRAPPER_SIZE}px;
  width: ${ICON_WRAPPER_SIZE}px;
  height: ${ICON_WRAPPER_SIZE}px;
  color: #fff;

  background: ${p =>
    p.type === 'pros'
      ? p.theme.ratings.positive.bg
      : p.theme.ratings.disabled.bg};

  svg {
    fill: ${p =>
      p.type === 'pros'
        ? p.theme.ratings.positive.fg
        : p.theme.ratings.disabled.fg};
  }
`;

export default function ProsAndCons({ strings, type }: Props) {
  if (!strings?.length) return null;

  return (
    <>
      {strings
        .filter(x => x)
        .map(
          string =>
            string && (
              <ProsConsRow key={string} type={type}>
                <Icon type={type}>
                  {type === 'pros' ? (
                    <PlusIcon size={ICON_SIZE} />
                  ) : (
                    <MinusIcon size={ICON_SIZE} />
                  )}
                </Icon>
                {string}
              </ProsConsRow>
            )
        )}
    </>
  );
}
